var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'button': true,'collectinfo': true,'collected': !_vm.fav},attrs:{"onClick":"{this.collectInfo.bind(this)}"}},[_c('i',{class:{icon:1,i_fav:_vm.fav,i_faved:!_vm.fav}})])}
var staticRenderFns = []

export { render, staticRenderFns }